import React, { useRef, useState, useEffect } from "react";
import "./youtubeEmbed.scss";
import { PlayIcon } from "../../../assets/Icons";
import { useWindowSize } from "react-use";

const YoutubeEmbed = ({
  id,
  videoId,
  thumbnail,
  mobileThumbnail,
  iconcss,
  iframecss,
  isHoveredIndex,
  setIsHoveredIndex,
}) => {
  const { width } = useWindowSize();
  const [shouldPlay, setShouldPlay] = useState(false);
  const containerRef = useRef(null);
  const timerRef = useRef(null);
  const isMobile = width <= 992;

  useEffect(() => {
    if (isMobile) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            timerRef.current = setTimeout(() => {
              setShouldPlay(true);
            }, 1000);
          } else {
            clearTimeout(timerRef.current);
            setShouldPlay(false);
          }
        },
        {
          threshold: 0.5,
        }
      );

      if (containerRef.current) {
        observer.observe(containerRef.current);
      }

      return () => {
        observer.disconnect();
        clearTimeout(timerRef.current);
      };
    }
  }, [isMobile]);

  const youtubeFrame = () => (
    <iframe
      className={`rounded-[20px] cursor- ${iframecss}`}
      src={`https://www.youtube.com/embed/${videoId}?playlist=${videoId}&rel=0&autoplay=1&mute=1&loop=1&controls=0`}
      title="YouTube video"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullScreen
      style={{ pointerEvents: "none" }}
    />
  );

  return (
    <div
      className="w-full h-full relative shadowanimation"
      onMouseEnter={() => !isMobile && setIsHoveredIndex(id)}
      onMouseLeave={() => !isMobile && setIsHoveredIndex(null)}
      ref={containerRef}
    >
      {isMobile ? (
        shouldPlay ? (
          <div
            className={`w-full h-full shadowanimation2 rounded-[20px] bg-glass/30`}
          >
            <div className={`w-full h-full shadowanimation1 p-2`}>
              {youtubeFrame()}
            </div>
          </div>
        ) : (
          <div className="h-full w-full relative">
            <img
              src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
              alt="Youtube Thumbnail"
              className="h-full w-full object-cover object-center"
            />
            <img
              src={PlayIcon}
              alt="Play Icon"
              className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
            />
          </div>
        )
      ) : isHoveredIndex === id ? (
        <div
          className={`w-full h-full shadowanimation2 rounded-[20px] bg-glass/30`}
        >
          <div className={`w-full h-full shadowanimation1 p-2`}>
            {youtubeFrame()}
          </div>
        </div>
      ) : (
        <div className="h-full w-full relative">
          <img
            src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
            alt="Youtube Thumbnail"
            className="h-full w-full object-cover object-top"
            // className="h-full w-full object-cover object-[5%]"
          />
          <img
            src={PlayIcon}
            alt="Play Icon"
            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
          />
        </div>
      )}
    </div>
  );
};

export default YoutubeEmbed;
